import { Button } from "@mui/material";
import { ArrowBackIos, Call, Search } from "@mui/icons-material";

const Title = ({ namePage, icon }) => {
  return (
    <>
      <span className="text-sm text-blue-700 cursor-pointer">
        <ArrowBackIos className="mr-2 text-sm" />
        Go Back
      </span>
      <header className="flex items-center justify-between w-full gap-2 p-4 mt-2 mb-8 bg-white rounded-md shadow-md flex-nowrap">
        {/* Title */}
        <div className="flex items-center gap-2">
          {icon}
          <h2 className="text-2xl">
            <b className="capitalize">{namePage}</b> - Follow Up
          </h2>
        </div>
        {/* Actions */}
        <div className="flex gap-2 justify-self-end">
          <Button
            className="text-xs normal-case bg-indigo-700 hover:bg-indigo-900 w-fit rounded-3xl"
            variant="contained"
          >
            View Client Details <Search fontSize="small" className="ml-2" />
          </Button>

          <Button
            className="text-xs text-indigo-700 normal-case bg-white border-indigo-700 hover:border-indigo-700 w-fit rounded-3xl"
            variant="outlined"
          >
            Call Client <Call fontSize="small" className="ml-2" />
          </Button>
        </div>
      </header>
    </>
  );
};

export default Title;
